import lodash from 'lodash';
import { enforceObservableRules } from '@exodus/atoms';
const { get: getValueAtPath, set: setValueAtPath, isEqual } = lodash;
export const createFusionAtom = ({ fusion, online, path, defaultValue, }) => {
    let prevValue;
    const set = async (value) => {
        await fusion.mergeProfile(setValueAtPath({}, path, value));
    };
    const get = async () => {
        const profile = await fusion.getProfile({ online });
        const currentValue = getValueAtPath(profile, path);
        if (isEqual(currentValue, prevValue)) {
            return prevValue;
        }
        prevValue = currentValue;
        return currentValue;
    };
    const observe = (listener) => {
        let prevValue;
        let subscribed = true;
        let called = false;
        const wrapper = (profile) => {
            if (subscribed) {
                const value = getValueAtPath(profile, path);
                if (called && isEqual(value, prevValue)) {
                    return;
                }
                prevValue = value;
                called = true;
                return listener(value);
            }
        };
        fusion.subscribe(wrapper);
        return () => {
            subscribed = false;
        };
    };
    return enforceObservableRules({
        get,
        set,
        observe,
        defaultValue,
    });
};
